export default __webpack_public_path__ + "static/buy-now-amazon-d071d8bb26ddf581e382bfe30ffbfaf4.png";